import React from "react";
import { Box, Typography, TextField } from "@mui/material";

const SmallTextForm = ({
  orderFormFieldKey,
  orderFormFieldTouched,
  orderFormFieldError,
  nameText,
  value,
  handleChange,
  handleBlur,
}) => {
  return (
    <Box
      xs={12}
      key={orderFormFieldKey}
      sx={{
        marginTop: "20px",
      }}
    >
      <Typography
        sx={{ marginBottom: "5px" }}
        color={
          orderFormFieldTouched && Boolean(orderFormFieldError) ? "error" : ""
        }
      >
        {nameText}
      </Typography>
      <TextField
        id={orderFormFieldKey}
        name={orderFormFieldKey}
        sx={{ width: "100%" }}
        variant="outlined"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        error={orderFormFieldTouched && Boolean(orderFormFieldError)}
        helperText={(orderFormFieldTouched && orderFormFieldError) || " "}
      />
    </Box>
  );
};

export default SmallTextForm; 